import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { AuthService } from '../core/auth.service';
import { Post } from '../core/post';
import { PostService } from '../core/post.service';

@Component({
  selector: 'app-modify-post',
  templateUrl: './modify-post.component.html',
  styleUrls: ['./modify-post.component.scss']
})
export class ModifyPostComponent implements OnInit {

  post: Post;
  licensePlate: String[];
  public chosenLicensePlate: string[] = [];
  date: string;
  message: string = '';
  public originalDate: string;

  form: FormGroup = this.fb.group({
    customer: ['', Validators.required],
    customerCode: ['', Validators.required],
    fromLocation: ['', Validators.required],
    toLocation: ['', Validators.required],
    concreteQuality: ['', Validators.required],
    concreteQuantity: ['', Validators.required],
    phoneNumber: ['', Validators.required],
    date: ['', Validators.required],
    time: ['', Validators.required],
    licenseNumbers: ['', Validators.required],
    comment: ['']
  })


  constructor(private route: ActivatedRoute, private postService: PostService, private fb: FormBuilder, private router: Router, private authService: AuthService, private datepipe: DatePipe) { }

  ngOnInit(): void {
    this.postService.getLicensePlates().subscribe(data => {
      this.licensePlate = data;
    }, error => {
      throwError(error);
    });

    const id = this.route.snapshot.paramMap.get('id');
    this.postService.getPost(id).subscribe(data => {
      this.post = data;
      this.chosenLicensePlate = this.post.licensePlateNumbers;
      this.originalDate = this.post.date;
      this.preloadData();
    }, error => throwError(error));
  }

  private preloadData() {
    this.form.patchValue({
      customer: this.post.customer,
      customerCode: this.post.customerCode,
      fromLocation: this.post.fromLocation,
      toLocation: this.post.toLocation,
      concreteQuality: this.post.concreteQuality,
      concreteQuantity: this.post.concreteQuantity,
      phoneNumber: this.post.phoneNumber,
      comment: this.post.comment,
      time: this.post.hour,
      date: new Date(this.post.date),
    });
  }

  submit(): void {
    if (!this.form.valid) {
      this.message = 'A munkalap módosító űrlap nem lett megfelelően kitöltve!';
      return;
    }
    this.postService.modify(this.post.postId, this.form.value.concreteQuality, this.form.value.concreteQuantity, this.form.value.customer, this.form.value.customerCode, this.form.value.fromLocation, this.form.value.toLocation, this.form.value.phoneNumber, this.post.userName, this.datepipe.transform(this.form.value.date, 'yyyy-MM-dd'), this.form.value.time, this.chosenLicensePlate, this.form.value.comment, this.post.priority).subscribe(success => {
      if (success) {
        this.router.navigate(['/day', this.originalDate]);
      }
    }, error => {
      throwError(error);
    });
  }

  backToDay(): void {
    this.router.navigate(['/day', this.originalDate]);
  }

}
